import { Component, Input } from '@angular/core';
import { CashFundsService, UserSummary } from '@libs/core/api';
import { Observable, switchMap, tap } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ToastService, LoadingService } from '@libs/ui/uikit';
import { FundCashPurchaseForm } from '../fund-cash-purchase-form/fund-cash-purchase-form.component';

@UntilDestroy()
@Component({
  selector: 'front-end-fund-cash-purchase-transfer',
  templateUrl: './fund-cash-purchase-transfer.component.html',
  styleUrls: ['./fund-cash-purchase-transfer.component.scss'],
})
export class FundCashPurchaseTransferComponent {
  private _subtaskId!: number;
  buyers$!: Observable<UserSummary[]>;

  selectedBuyerId: number | null = null;

  @Input()
  set subtaskId(value: number) {
    this._subtaskId = value;
    this.buyers$ = this.cashFundService.getSubtaskBuyers({ subtaskId: value });
  }

  get subtaskId(): number {
    return this._subtaskId;
  }

  @Input() cashFund!: FundCashPurchaseForm;
  @Input() cashFundId?: number;

  constructor(
    private cashFundService: CashFundsService,
    private modalController: ModalController,
    private toastService: ToastService,
    private loadingService: LoadingService
  ) {}

  close() {
    this.modalController.dismiss();
  }

  async save() {
    if (this.cashFundId) {
      this.cashFundService
        .putTransfer({
          id: this.cashFundId as number,
          body: {
            assignedUserId: this.selectedBuyerId as number,
          },
        })
        .pipe(
          tap(() => {
            this.modalController.dismiss(true);
          }),
          this.loadingService.withLoading(),
          this.toastService.catchAndThrowErrorWithToast(),
          untilDestroyed(this)
        )
        .subscribe();
    } else {
      this.cashFundService
        .createCashFund({
          body: {
            articleId: this.cashFund.articleId.value as number,
            subtaskId: this.subtaskId,
            comment: this.cashFund.notes.value as string,
            isDraft: true,
          },
        })
        .pipe(
          switchMap((cf) =>
            this.cashFundService
              .putTransfer({
                id: cf.id as number,
                body: {
                  assignedUserId: this.selectedBuyerId as number,
                },
              })
              .pipe(
                tap(() => {
                  this.modalController.dismiss(true);
                })
              )
          ),
          this.loadingService.withLoading(),
          this.toastService.catchAndThrowErrorWithToast(),
          untilDestroyed(this)
        )
        .subscribe();
    }
  }
}
